// @ts-nocheck
import PropTypes from 'prop-types';
import React from 'react';
import ButtonSubmitDeprecated from '../../common/btn-submit/btn-submit';
import Button from 'gd-comp-button';

import Classes from 'classnames';

// Deprecated

export default class GDFormModal extends React.Component<any,any> {

    static propTypes = {
        submitLabel: PropTypes.string,
        form: PropTypes.object.isRequired,

        submitButton: PropTypes.bool,
        cancelButton: PropTypes.bool,
        onCancelClick: PropTypes.func
    };

    static defaultProps = {
        submitLabel: 'Submit',
        submitButton: true,
        cancelButton: false
    };

    render() {
        let buttonCancel;

        if (this.props.cancelButton===true) {
            buttonCancel = <Button type="normal" label="Cancel" onClick={this.props.onCancelClick} className="btn-cancel" />
        }

        return (
            <div className={Classes("gd-form-modal-new", this.props.className)}>

                {this.props.children}

                {(this.props.submitButton || this.props.cancelButton) &&
                <div className="actions">
                    <ButtonSubmitDeprecated form={this.props.form} label={this.props.submitLabel} className="submit" /> {buttonCancel}
                </div>}

            </div>
        );
    }
}